import * as lib from '@vebox/etui-icons';
import { icons } from './icons.js';

const getIcon = glyph => {
  const arr = Object.values(icons).map(icon => {
    const iconName = icon
    // Split the icon name by '-' or '_'
    .split(/[-_]/)
    // Capitalize the first letter of each word
    .map(name => {
      const firstLetter = name[0].toUpperCase();
      return `${firstLetter}${name.slice(1)}`;
    }).join('');
    if (glyph === icons.CSV) {
      return {
        glyph: icon,
        iconName: `${iconName.toUpperCase()}Glyph`
      };
    }
    if (glyph === icons.HP_CONTROL) {
      return {
        glyph,
        iconName: 'HPControlGlyph'
      };
    }
    if (glyph === icons.HVAC_COPY) {
      return {
        glyph,
        iconName: 'HVACCopyGlyph'
      };
    }
    if (glyph === icons.HVAC_LAYOUT) {
      return {
        glyph,
        iconName: 'HVACLayoutGlyph'
      };
    }
    return {
      glyph: icon,
      iconName: `${iconName}Glyph`
    };
  });
  const myIcon = arr.find(icon => icon.glyph === glyph);
  if (myIcon) {
    return lib[myIcon.iconName];
  }
  return null;
};

export { getIcon };
